import { render, staticRenderFns } from "./MyEmpty.vue?vue&type=template&id=3536a3a6&scoped=true&"
import script from "./MyEmpty.vue?vue&type=script&lang=js&"
export * from "./MyEmpty.vue?vue&type=script&lang=js&"
import style0 from "./MyEmpty.vue?vue&type=style&index=0&id=3536a3a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3536a3a6",
  null
  
)

export default component.exports